import moment from "moment";
import React, { useRef } from "react";
import QRCode from "react-qr-code";
import Styles from "./style.module.scss";
import generatePDF from "react-to-pdf";
import { useMemo } from "react";
import Images from "@Theme/Images";

export default function CertificateLayout({ courseId, data }) {
  const ref1 = useRef();
  const ref2 = useRef();

  //   TOKOPEDIA = 'TOKOPEDIA',
  //   BUKALAPAK = 'BUKALAPAK',
  //   PINTAR = 'PINTAR',
  //   TEST = 'TEST',

  const templateCertificate = useMemo(() => {
    if (!!data.certificate.predicate) {
      switch (data.certificate.partner) {
        case "TEST":
          return Images.KELULUSAN_TOKOPEDIA_BAIK;
        case "TOKOPEDIA":
          return Images.KELULUSAN_TOKOPEDIA_BAIK;
        case "PINTAR":
          return Images.KELULUSAN_PINTAR_BAIK;
        case "BUKALAPAK":
          return Images.KELULUSAN_BUKALAPAK_BAIK;
        default:
          return Images.KELULUSAN_TOKOPEDIA_BAIK;
      }
    } else {
      switch (data.certificate.partner) {
        case "TEST":
          return Images.KELULUSAN_TOKOPEDIA;
        case "TOKOPEDIA":
          return Images.KELULUSAN_TOKOPEDIA;
        case "PINTAR":
          return Images.KELULUSAN_PINTAR;
        case "BUKALAPAK":
          return Images.KELULUSAN_BUKALAPAK;
        default:
          return Images.KELULUSAN_TOKOPEDIA;
      }
    }
  }, [data]);

  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        <div className={Styles.buttonContainer}>
          <button
            onClick={() =>
              generatePDF(ref1, {
                filename: "page.pdf",
                page: { orientation: "landscape" },
              })
            }
            className={Styles.customButton}
          >
            Download
          </button>
          <div ref={ref1} className={Styles.certificateWrapper}>
            <img
              src={templateCertificate}
              alt="cert"
              className={Styles.imageContainer}
            />
            <h4
              className={`${Styles.certificateText} ${Styles.courseName}`}
              predicate={!!data.certificate.predicate ? "true" : "false"}
            >
              {data.certificate.courseName}
            </h4>
            <h1
              className={`${Styles.certificateText} ${Styles.certificateName}`}
              predicate={!!data.certificate.predicate ? "true" : "false"}
            >
              {data.certificate.name}
            </h1>
            <h6
              className={`${Styles.certificateText} ${Styles.certificateDate}`}
            >
              {moment(data.certificate.createdAt).format("dddd, Do MMMM YYYY")}
            </h6>
            <div className={Styles.qrContainer}>
              <QRCode
                style={{
                  height: "150px",
                  width: "150px",
                  maxWidth: "100%",
                }}
                value={window.location.href}
                viewBox={`0 0 256 256`}
              />
              <p className={`${Styles.certificateText}`}>
                No.{data.certificate.certificateGenerateDate}
              </p>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "4rem" }}>
          <button
            onClick={() =>
              generatePDF(ref2, {
                filename: "page.pdf",
                page: { orientation: "landscape" },
              })
            }
            className={Styles.customButton}
          >
            Download
          </button>
          <div ref={ref2} className={Styles.certificateWrapper}>
            <img
              src={Images.DAFTAR_PENILAIAN}
              alt="cert"
              className={Styles.imageContainer}
            />
            <div className={Styles.scoreTextContainer}>
              <p className={`${Styles.competenceTitle}`}>
                {data?.competency[0]?.unitValue}
              </p>
            </div>
            <div className={Styles.competenceUnitContainer}>
              {data.competency.map((el, idx) => (
                <p key={idx} className={`${Styles.competence}`}>
                  <span className={Styles.fontBold}>
                    {idx + 1}. {el.unitCode}
                  </span>{" "}
                  - {el.unitCategory}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
